'use client'

import React, { useContext } from 'react'
import { ContextMenu } from '../../molecules'
import { Button, ButtonVariants } from '../../atoms'
import { FilterIcon } from '../../icons'
import { ComponentTranslationContext } from '../../../providers'
import { MESSAGE_KEYS } from '../../../constants/messageKeys'

interface TimelineFilterWrapperProps extends React.HTMLAttributes<HTMLDivElement> {}

export const TimelineFilterWrapper = ({ children }: TimelineFilterWrapperProps): JSX.Element => {
    if (!children) return <></>
    const translations = useContext(ComponentTranslationContext)

    return (
        <ContextMenu
            className="max-h-[70%] overflow-y-scroll"
            toggleButton={
                <Button variant={ButtonVariants.QUIET} icon={<FilterIcon />}>
                    {translations.getLabel(MESSAGE_KEYS.FILTERS)}
                </Button>
            }
        >
            {children}
        </ContextMenu>
    )
}
